import { render, staticRenderFns } from "./passDetailPage.vue?vue&type=template&id=01f6f2fd&"
import script from "./passDetailPage.vue?vue&type=script&lang=ts&"
export * from "./passDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports